import { useState, useRef, useCallback } from "react";

// A smooth "fake" progress bar that eases toward ~95% over an estimated
// duration, then snaps to 100% when done() is called.
export function useFakeProgress() {
  const [progress, setProgress] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const timer = useRef(null);
  const startTs = useRef(0);
  const est = useRef(45);

  const start = useCallback((estimate = 45) => {
    est.current = estimate;
    startTs.current = Date.now();
    setProgress(0);
    setElapsed(0);
    clearInterval(timer.current);
    timer.current = setInterval(() => {
      const e = (Date.now() - startTs.current) / 1000;
      setElapsed(e);
      const p = Math.min(95, 100 * (1 - Math.exp(-e / (est.current * 0.55))));
      setProgress(p);
    }, 200);
  }, []);

  const done = useCallback(() => {
    clearInterval(timer.current);
    setProgress(100);
  }, []);

  const reset = useCallback(() => {
    clearInterval(timer.current);
    setProgress(0);
    setElapsed(0);
  }, []);

  return { progress, elapsed, est: est.current, start, done, reset };
}
